import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicosPage = lazy(() => import('../pages/servicos/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const RemodelacoesPage = lazy(() => import('../pages/remodelacoes/page'));
const PinturaPage = lazy(() => import('../pages/pintura/page'));
const PavimentoMadeiraPage = lazy(() => import('../pages/pavimento-madeira/page'));
const PavimentacaoCeramicaPage = lazy(() => import('../pages/pavimentacao-ceramica/page'));
const InstalacaoMoveisPage = lazy(() => import('../pages/instalacao-moveis/page'));
const MoveisMedidaPage = lazy(() => import('../pages/moveis-medida/page'));
const GaleriaPage = lazy(() => import('../pages/galeria/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/post'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/servicos',
    element: <ServicosPage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/remodelacoes',
    element: <RemodelacoesPage />,
  },
  {
    path: '/pintura',
    element: <PinturaPage />,
  },
  {
    path: '/pavimento-madeira',
    element: <PavimentoMadeiraPage />,
  },
  {
    path: '/pavimentacao-ceramica',
    element: <PavimentacaoCeramicaPage />,
  },
  {
    path: '/instalacao-moveis',
    element: <InstalacaoMoveisPage />,
  },
  {
    path: '/moveis-medida',
    element: <MoveisMedidaPage />,
  },
  {
    path: '/galeria',
    element: <GaleriaPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;